var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchasewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.619141 0.557617H2.26188C3.2815 0.557617 4.08398 1.43563 3.99902 2.44581L3.21541 11.849C3.08324 13.3879 4.30112 14.7096 5.84944 14.7096H15.9041C17.2636 14.7096 18.4532 13.5956 18.557 12.2456L19.0668 5.16482C19.1801 3.59762 17.9905 2.32308 16.4139 2.32308H4.2256",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0727 19.4403C14.7245 19.4403 15.2528 18.912 15.2528 18.2602C15.2528 17.6084 14.7245 17.0801 14.0727 17.0801C13.4209 17.0801 12.8926 17.6084 12.8926 18.2602C12.8926 18.912 13.4209 19.4403 14.0727 19.4403Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51997 19.4403C7.17173 19.4403 7.70009 18.912 7.70009 18.2602C7.70009 17.6084 7.17173 17.0801 6.51997 17.0801C5.8682 17.0801 5.33984 17.6084 5.33984 18.2602C5.33984 18.912 5.8682 19.4403 6.51997 19.4403Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22852 6.22266H18.5577",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchasewhite);
export default __webpack_public_path__ + "static/media/purchasewhite.41e6173e9e99234fcc0906adac0ad799.svg";
export { ForwardRef as ReactComponent };